<template>
  <div class="l-container ContractIndex">
    <h1 class="m-label">contract情報</h1>

    <template v-if="contract.id !== edit_id.edit_id">
      <div class="index-box">
        <div style="display: flex; flex-flow: row wrap">

          <div>
            <div class="th">ID</div>
            <div class="td">{{contract.id}}</div>
          </div>
          <div>
            <div class="th">contract_date</div>
            <div class="td">{{contract.contract_date}}</div>
          </div>
          <div>
            <div class="th">cancel_type</div>
            <div class="td">{{contract.cancel_type}}</div>
          </div>
          <div>
            <div class="th">office</div>
            <div class="td">{{contract.office}}</div>
          </div>
          <div>
            <div class="th">作成日</div>
            <div class="td">{{contract.created_at.substring(0, 10)}}</div>
          </div>
          <div>
            <div class="th">更新日</div>
            <div class="td">{{contract.updated_at.substring(0, 10)}}</div>
          </div>

        </div>
      </div>
      <div style="display: flex">
        <btn @click.native="deletecontract(contract)" style="margin-top: 1rem !important">削除</btn>
        <btn @click.native="edit(contract)">編集</btn>
      </div>
    </template>

    <template v-if="contract.id == edit_id.edit_id">
      <div class="index-box">
        <div style="display: flex; flex-flow: row wrap">

          <div>
            <div class="th">ID</div>
            <div class="td">{{contract.id}}</div>
          </div>
          <div>
            <div class="th">contract_date</div>
            <div class="td"><input type="text" v-model="contract.date"></div>
          </div>
          <div>
            <div class="th">cancel_type</div>
            <div class="td"><input type="text" v-model="contract.cancel_type"></div>
          </div>
          <div>
            <div class="th">office</div>
            <div class="td select"><multiselect v-model="watch.office" :options="Office" label="name" placeholder="office" :show-labels="false"></multiselect></div>
          </div>
          <div>
            <div class="th">作成日</div>
            <div class="td"><input type="text" v-model="contract.created_at"></div>
          </div>
          <div>
            <div class="th">更新日</div>
            <div class="td"><input type="text" v-model="contract.updated_at"></div>
          </div>

        </div>
      </div>
      <div style="display: flex">
        <btn @click.native="cancelcontract(contract)" style="margin-top: 1rem !important">戻る</btn>
        <btn @click.native="patchcontract(contract)">更新</btn>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    contract: Object
  },
  computed: {
    // advisors () {
    //   return this.$store.getters.advisors
    // }
  },
  data () {
    return {
      column: false,

      edit_id: {
        edit_id: ''
      },

      id: true,
      contract_date: true,
      cancel_type: true,
      office: true,
      created_at: true,
      updated_at: true,

      watch: {
        office: ''
      },

      Office: [
        { name: '未選択', value: '未選択' },
        { name: '仙台', value: '仙台' },
        { name: '札幌', value: '札幌' },
        { name: '名古屋', value: '名古屋' },
        { name: '福岡', value: '福岡' },
        { name: '新宿', value: '新宿' },
        { name: '高松', value: '高松' },
        { name: '大宮', value: '大宮' },
        { name: '高崎', value: '高崎' },
        { name: '東京', value: '東京' }
      ]
    }
  },
  watch: {
    'watch.office': function (now, old) {
      // console.log(now)
      if (now) {
        this.contract.office = now.value
      } else {
        this.contract.office = ''
      }
    }
  },
  methods: {
    edit (contract) {
      // console.log(contract)
      this.watch.type = { name: contract.type, value: contract.type }
      this.watch.office = { name: contract.office, value: contract.office }
      this.edit_id.edit_id = contract.id
    },

    switchV (col) {
      this[col] = !this[col]
    },

    deleteContract (list) {
      this.$store.dispatch('deleteContract', {
        this: this,
        list: list
      })
    },

    cancelContract (list) {
      this.$store.dispatch('cancelContract', {
        this: this,
        list: list,
        edit_id: this.edit_id
      })
    },

    patchContract (list) {
      this.$store.dispatch('patchContract', {
        this: this,
        list: list,
        edit_id: this.edit_id
      })
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
/* button { */
/*   background: #fbfbfb; */
/*   color: #000; */
/*   border-left: solid 1px #fff; */
/*   border-right: 0; */
/*   border-top: 0; */
/*   border-bottom: solid 1px #fff; */
/*   outline: 0; */
/*   cursor: pointer; */
/*   width: 160px; */
/* } */
.active {
  background: #455A64;
  color: #fff;
  border-left: solid 1px #fff;
  border-right: 0;
  border-top: 0;
  border-bottom: solid 1px #fff;
}
.btn {
  /* background: #cdeeff; */
  cursor: pointer;
  z-index: 1;
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 1rem 0.5rem !important;
  border: solid 1px #ccc;
  height: 40px;
  width: 200px;
}
.th {
  background: #fbfbfb;
}
.select {
  padding: 0 !important;
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
.index-box {
  /* box-shadow: 1px 1px 1px #ccc; */
  /* border: solid 1px #ccc; */
  height: calc(100vh - 210px);
  overflow: scroll;
  margin-top: 10px;
}
.del {
  text-align: center;
  cursor: pointer;
  &:hover {
    background: black;
    color: white;
  }
}
</style>
<style lang="scss">
.ContractIndex {
  .multiselect {
    min-height: 35px;
    min-width: 150px;
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    min-height: 35px;
    padding: 0px 23px 0 2px;
    border-radius: 0;
    border: none;
    margin: 1px;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 35px;
  }
  .multiselect__select {
    height: 35px;
    width: 26px;
    top: 2px;
    padding: 0;
  }
  .vdp-datepicker {
    input {
      height: 37px;
      border: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ContractIndex.vue?748a169c